import { render, staticRenderFns } from "./KAZ.vue?vue&type=template&id=dbf34444&scoped=true&"
import script from "./KAZ.vue?vue&type=script&lang=js&"
export * from "./KAZ.vue?vue&type=script&lang=js&"
import style0 from "./KAZ.vue?vue&type=style&index=0&id=dbf34444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf34444",
  null
  
)

export default component.exports